import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  Collapse,
  Card,
  Row,
  Col,
} from 'reactstrap';
import AvgRetailRow from './AvgRetailRow';

function AvgRetailBox({ showAvgRetail, dosages, avgRetailPrices }) {
  const years = Object.keys(avgRetailPrices);
  const [year, setYear] = useState(years[0]);

  return (
    <Collapse isOpen={showAvgRetail}>
      <h6>Enter your Average Retail Price</h6>
      <label
        htmlFor="avgRetailPriceYear"
        className="col-form-label"
      >
        Year:
      </label>
      <select
        id="avgRetailPriceYear"
        className="form-select mb-2"
        onChange={(e) => setYear(e.target.value)}
      >
        {years.map((y) => (
          <option key={y} value={y}>{y}</option>
        ))}
      </select>
      <Card className="mb-4 p-2">
        <Row>
          <Col tag="h6">Drug Name Dosage</Col>
          <Col tag="h6" xs="6">ARP</Col>
        </Row>
        {dosages.map((dosage) => (
          <AvgRetailRow
            dosage={dosage.id}
            key={dosage.id}
            label={dosage.name}
            year={year}
          />
        ))}
      </Card>
    </Collapse>
  );
}

const mapStateToProps = (state) => ({
  avgRetailPrices: state.sites.values?.avgRetailPrices || {},
  showAvgRetail: state.sites.values?.avgRetail,
  dosages: state.sites.values?.dosages ?? [],
});

export default connect(mapStateToProps)(AvgRetailBox);
